/** @prettier */
import { connect } from 'react-redux';

import { subscribeToEvent, unsubscribeToEvent } from '@xanadu/ui-shared/modules/event/actions';
import { getCalendar } from '@xanadu/ui-shared/modules/events/actions';
import { getEventFromCalendar } from '@xanadu/ui-shared/modules/events/selectors';

import NextUpEvent from '../../components/widgets/NextUpEvent';

const mapDispatchToProps = {
  subscribeToEvent,
  unsubscribeToEvent,
  getCalendar,
};

function mapStateToProps(state, { sportUrlName }) {
  const product = state.getIn(['application', 'product']);

  const { id, name } = getEventFromCalendar(state, `${product}_${sportUrlName}`);

  const { inRunningFlag, status } = state.getIn(['event', id], {});

  return {
    id,
    name,
    status,
    inRunningFlag,
    product,
    sportUrlName,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NextUpEvent);
